<template>
  <div class="relative">
    <button
      class="flex flex-col justify-center p-4 text-center border-l border-b cursor-pointer h-full w-16 sm:w-32"
      @click.stop="toggleBasket()"
    >
      <div class="flex gap-1 items-center mx-auto">
        <div
          class="inline-block relative pr-3 -mx-1"
          :class="{ 'md:mx-0 md:ml-3': authStore.isBrandedModeUser, 'sm:mx-0 sm:ml-3': !authStore.isBrandedModeUser }"
        >
          <div class="text-2xl">
            <i class="fal fa-shopping-basket" />
          </div>
          <div
            class="rounded-full bg-green-600 text-white absolute bottom-0 right-0 flex flex-col justify-around w-5 h-5 text-xs"
          >
            {{ basketStore.getContractIdentifier?.basketQty || 0 }}
          </div>
        </div>
        <i v-if="visible" class="fal fa-chevron-up" :style="{ 'line-height': '2rem' }" />
        <i v-else class="fal fa-chevron-down" :style="{ 'line-height': '2rem' }" />
      </div>
      <div class="hidden sm:block text-sm mt-3">
        <div class="whitespace-nowrap">
          <span v-if="basketStore.getContractIdentifier?.basketQty > 0">
            {{ basketStore.getContractIdentifier?.basketQty }}
          </span>
          <span v-else> No </span>
          <span v-if="basketStore.getContractIdentifier?.basketQty === 1"> item </span>
          <span v-else> items </span>
        </div>
        <div v-if="authStore.isBrandedModeUser">
          <span>in Basket</span>
        </div>
        <div v-else-if="basketStore.getContractIdentifier?.contractType">
          <span>{{ `in ${basketStore.getContractIdentifier?.contractType || 'Basket'}` }}</span>
        </div>
        <div v-else>
          <span>in Basket</span>
        </div>
      </div>
    </button>
    <div v-show="visible">
      <div class="absolute top-0 left-0 right-0 bottom-0 z-40 cursor-pointer" @click.stop="visible = false" />
      <div class="relative">
        <div
          class="absolute inline-block shadow-xl bg-white right-0 top-0 w-64 p-6 text-xs overflow-x-auto z-50"
          style="max-height: 70vh"
        >
          <template v-if="basketStore.getContractIdentifier?.basketQty > 0">
            <div v-for="item in basketStore.basket" :key="item.x">
              <div v-if="item.description" class="flex flex-wrap justify-between mb-3">
                <strong>{{ item.description }}</strong>
                <strong v-if="hasPricing">{{ formatCurrency(basketStore.getCurrency, item.price) }}</strong>
              </div>
              <div v-else class="flex flex-wrap justify-between">
                <strong>{{ item.code }}</strong>
                <strong v-if="hasPricing">{{ formatCurrency(basketStore.getCurrency, item.price) }}</strong>
              </div>
              <div v-if="item.code" class="flex flex-wrap justify-between">
                <strong class="pr-2">Code:</strong>
                <span v-text="item.code" />
              </div>
              <div v-if="item.color" class="flex flex-wrap justify-between">
                <strong class="pr-2">Colour:</strong>
                <span v-text="item.color" />
              </div>
              <div v-if="basketStore.contractHasSizing && item.size" class="flex flex-wrap justify-between">
                <strong class="pr-2">Size:</strong>
                <span v-text="item.size" />
              </div>
              <div class="flex flex-wrap justify-between">
                <strong class="pr-2">Qty:</strong>
                <span v-text="item.quantity" />
              </div>
              <hr class="my-3" />
            </div>
            <strong v-if="hasPricing" class="flex flex-wrap justify-between">
              <span>Total:</span> <span>{{ formatCurrency(basketStore.getCurrency, basketStore.total) }}</span>
            </strong>
            <router-link :to="basketLink" class="btn btn-action w-full mt-6" @click="visible = false">
              Show Full Basket
            </router-link>
          </template>
          <template v-else>
            <div v-if="authStore.isBrandedModeUser" class="flex flex-col gap-3">
              <p>No Items in basket.</p>
              <router-link :to="brandedStore.chooseProductURL" type="button" class="btn btn-action w-full">
                Design a Product
              </router-link>
            </div>
            <div v-else-if="basketStore.getContractIdentifier" class="flex flex-col gap-3">
              <p>No Items in Basket.</p>
              <div type="button" class="btn btn-action w-full" @click="reloadRedirect">Add Item</div>
            </div>
            <div v-else class="flex flex-col gap-3">
              <p>No Items in Basket.</p>
              <router-link to="/new-quote" type="button" class="btn btn-action w-full"> Create Quote </router-link>
              <router-link to="/new-order" type="button" class="btn btn-action w-full"> Create Order </router-link>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { processingReloadContract } from '@/api'
import { useAuthStore } from '@/pinia/auth'
import { useBasketStore } from '@/pinia/basket'
import { useBrandedStore } from '@/pinia/branded'
import { useCustomerStore } from '@/pinia/customer'
import { formatCurrency } from '@/utils/currency'
import { mapStores } from 'pinia'

export default {
  props: ['not_on_basket_page', 'on_home_page', 'on_designer_page'],
  setup() {
    return { formatCurrency }
  },
  data() {
    return {
      visible: false,
      hover: false
    }
  },
  computed: {
    ...mapStores(useBrandedStore, useCustomerStore, useBasketStore, useAuthStore),
    hasPricing() {
      return !this.authStore.isBrandedModeUser || this.customerStore.hasBrandedPricingOn
    },
    basketLink() {
      return this.authStore.isBrandedModeUser ? { path: this.brandedStore.basketURL } : '/basket'
    }
  },
  methods: {
    toggleBasket() {
      this.visible = !this.visible
    },
    async reloadRedirect() {
      await processingReloadContract(this.basketStore.customerId, this.basketStore.getContractIdentifier.contractId)
      this.$router.push('/choose-product')
      this.toggleBasket()
    }
  }
}
</script>
